var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['img-wrap', {'round': _vm.round}],style:(_vm.style),on:{"click":_vm.onClick}},[_c('img',{key:_vm.imgKey,class:[{'avatar':_vm.isAvatar},{'round': _vm.round}, {'img': _vm.scale}],attrs:{"src":_vm.url || _vm.defaultUrl,"width":_vm.width,"height":_vm.height,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }